export const meKeys = {
  all: ['me'] as const,
  status: () => [...meKeys.all, 'status'] as const,
  employeeRecord: () => [...meKeys.all, 'employeeRecord'] as const,
};
